import MemberWelfare from './member_welfare.vue'

export default {
    path: 'memberWelfare',
    component: MemberWelfare
}
